import { render, staticRenderFns } from "./DocumentPage.vue?vue&type=template&id=367454bd&scoped=true&"
import script from "./DocumentPage.vue?vue&type=script&lang=js&"
export * from "./DocumentPage.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/document_page.scss?vue&type=style&index=0&id=367454bd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367454bd",
  null
  
)

export default component.exports